<template>
  <v-row wrap>
    <v-col cols="10">      <div class="pb-2">
      <label class="caption">Pencarian Lokasi</label>
      <vue-google-autocomplete
        ref="address"
        id="map"
        class="search-location"
        placeholder="Lokasi"
        v-on:placechanged="getDataAlamat"
        @change="getLongLat"
        @keydown.enter="getLongLat"
      ></vue-google-autocomplete>
      <p
        class="caption red--text py-1"
      >Tuliskan nama lokasi kemudian pilih lokasi dari beberapa pilihan yang muncul. Atau bisa dengan inputkan titik koordinat (longtitude-latiitude) secara langsung. Anda dapat pula menggerer titik lokasi untuk menyesuaikan</p>
<!--      <button class="btn" @click="resetPathAreaPresensi">-->
<!--      <v-icon small color="white" left>mdi-refresh</v-icon>Reset &nbsp;-->
<!--      </button>-->
    </div>

      </v-col>
    <v-col cols="2" class="pt-8 px-0">
      <v-btn height="45px" :large="$vuetify.breakpoint.mdAndUp" :small="$vuetify.breakpoint.smAndDown" color="primary" @click="setMyLocation" >
        <v-icon>mdi-target</v-icon>
      </v-btn>
    </v-col>
    <v-col cols="12">
      <gmap-map
        id="map"
        ref="mymap"
        :center="center"
        :zoom="19"
        :clickable="true"
        @click="setMarker2"
        style="width: 100%; height: 500px"
      >
        <GmapCircle
          v-for="pin in marker"
          :key="pin.latitude"
          :center="pin.position"
          :visible="true"
          :options="{
            fillColor: 'red',
            fillOpacity: 0.3,
            strokeOpacity: 0.1,
            strokeWeight: 0.5
          }"
        ></GmapCircle>
        <gmap-polygon
          :paths="pathAreaPresensi"
          :editable="true"
          @paths_changed="updateEdited($event)"
        ></gmap-polygon>
        <GmapMarker
          v-for="(item, index) in marker"
          :draggable="true"
          @dragend="updateCoordinates"
          :key="index"
          :position="item.position"
        />
      </gmap-map>
    </v-col>
  </v-row>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
import VueGoogleAutocomplete from "vue-google-autocomplete";
export default {
  components: {
    VueGoogleAutocomplete,
  },
  props: {
    mapUpdated: {
      default: 0,
    },
  },
  data() {
    return {
      current_place: null,
      paths: [],
      center: { lat: 0, lng: 0 },
      marker: [],
      pathAreaPresensi: [],
    };
  },
  computed: {
    google: gmapApi,
  },
  mounted() {
    this.getCurrentLocation()
    this.$nextTick(() => {
      // this.$refs.mymap.$gmapApiPromiseLazy().then(this.loadControls);
    });
  },

  methods: {
    setUlang(lokasi) {
      const marker = {
        lat: parseFloat(lokasi.latitude),
        lng: parseFloat(lokasi.longitude),
      };

      this.marker = [];

      this.marker.push({ position: marker });
      this.center = marker;
    },
    //set center gmap saat pertama kali dibuka
    getCurrentLocation() {
      navigator.geolocation.getCurrentPosition((position) => {
        var currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        this.center = currentLocation;
      });
    },
    setMyLocation(){
      var ref = this
      var geocoder = new this.google.maps.Geocoder;
      navigator.geolocation.getCurrentPosition((position) => {
        var currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        geocoder.geocode({'location': currentLocation}, function(results, status) {
          if (status === 'OK') {
            ref.$emit('setAlamat', results)
            if (results[1]) {
              ref.$refs.address.autocompleteText = results[1].formatted_address

            } else {
              window.alert('Alamat tidak ditemukan');
            }
          }
        })

        this.center = currentLocation;
        this.$refs.mymap.panTo(this.center)
        this.marker = [];

        this.marker.push({ position: currentLocation });
        this.$nextTick(() => {
          this.$emit("changeKordinat", this.marker);
        });
      });
    },
    setMarker2(data) {
      const marker = {
        lat: data.latLng.lat(),
        lng: data.latLng.lng(),
      };

      var ref = this
      var geocoder = new this.google.maps.Geocoder;
      navigator.geolocation.getCurrentPosition(() => {
        geocoder.geocode({'location': marker}, function(results, status) {
          if (status === 'OK') {
            ref.$emit('setAlamat', results)
            if (results[1]) {

              ref.$refs.address.autocompleteText = results[1].formatted_address

            } else {
              window.alert('Alamat tidak ditemukan');
            }
          }
        })

        this.marker = [];

        this.marker.push({ position: marker });
        this.$nextTick(() => {
          this.$emit("changeKordinat", this.marker);
        });
      });

      this.marker = [];

      this.marker.push({ position: marker });
      this.center = marker;
      this.$nextTick(() => {
        this.$emit("changeKordinat", this.marker);
      });
    },

    //resetPathAreaPresensi data path area absensi dan current_place
    resetPathAreaPresensi() {
      this.pathAreaPresensi = [];
      this.current_place = null;
    },

    // set lokasi marker berdasarkan alamat yang dipilih
    // eslint-disable-next-line
    getDataAlamat(addressData, placeResultData, id) {
      this.currentPlace = addressData;
      this.setMarker();
      this.$emit("changeLocation", addressData, this.radius);
    },
    // mengaktifkan drawing path di gmap
    loadMapDrawingManager() {
      this.$refs.mymap.$mapPromise.then(() => {
        const drawingManager = new this.google.maps.drawing.DrawingManager({
          drawingControl: true,
          drawingControlOptions: {
            position: this.google.maps.ControlPosition.TOP_CENTER,
            drawingModes: [this.google.maps.drawing.OverlayType.POLYGON],
          },
          polygonOptions: {
            fillColor: "#0099FF",
            fillOpacity: 0.7,
            strokeColor: "#AA2143",
            strokeWeight: 4,
            editable: true,
          },
        });
        drawingManager.setMap(this.$refs.mymap.$mapObject);
        //simpan path polygon saat drawing polygon selesai
        this.google.maps.event.addListener(
          drawingManager,
          "overlaycomplete",
          (event) => {
            // Get overlay paths
            let paths = event.overlay.getPaths().getArray();
            // Hapus overlay dari map
            event.overlay.setMap(null);
            // Disable drawingManager
            drawingManager.setDrawingMode(null);
            //simpan path polygon
            this.savePolygon(paths[0].g);
          }
        );
      });
    },

    //simpan data path polygon
    savePolygon(paths) {
      var kordinatArea = [];
      // push setiap data kordinat path ke data kordinat area
      paths.forEach((coordinate) => {
        const latlngPolygon = { lat: coordinate.lat(), lng: coordinate.lng() };
        kordinatArea.push(latlngPolygon);
      });
      this.pathAreaPresensi.push(kordinatArea);
      this.$emit("changePathAreaPresensi", kordinatArea);
    },

    //set marker di gmap berdasarkan data input current_place
    setMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.latitude,
          lng: this.currentPlace.longitude,
        };

        this.marker.push({ position: marker });
        this.center = marker;
      }
    },

    // set ulang marker di gmap saat marker di drag
    updateCoordinates(location) {
      this.center = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
      this.markers = [{ position: this.center }];
      this.$nextTick(() => {
        this.$emit("changeKordinat", this.markers);
      });
    },

    //set ulang path polygon di gmap jika path  diubah
    updateEdited(arrayPath) {
      let paths = [];
      for (let i = 0; i < arrayPath.getLength(); i++) {
        let path = [];
        for (let j = 0; j < arrayPath.getAt(i).getLength(); j++) {
          let point = arrayPath.getAt(i).getAt(j);
          path.push({ lat: point.lat(), lng: point.lng() });
        }
        paths.push(path);
      }
      this.pathAreaPresensi = paths;
      this.$emit("changePathAreaPresensi", paths[0]);
    },

    // method alternatif untuk drawing path di gmap
    // loadDrawingPolyline() {
    //   this.$refs.mymap.$mapPromise.then(map => {
    //     var polyOptions = {
    //       geodesic: true,
    //       strokeColor: "rgb(20,120,218)",
    //       strokeOpacity: 1.0,
    //       strokeWeight: 2,
    //       editable: true
    //     };

    //     var poly = new this.google.maps.Polyline(polyOptions);
    //     poly.setMap(map);

    //     map.addListener("click", event => {
    //       var path = poly.getPath();
    //       path.push(event.latLng);

    //       var kordinatPoligon = poly.getPath();
    //       var kordinatArea = [];

    //       kordinatPoligon.forEach(coordinate => {
    //         const latPoly = coordinate.lat();
    //         const lngPoly = coordinate.lng();

    //         const latlngPoly = [latPoly, lngPoly];

    //         kordinatArea.push(latlngPoly);
    //       });
    //       this.pathAreaPresensi.push(kordinatArea);
    //     });
    //   });
    // },

    async getLongLat(data) {
      if (!data) return
      const geocoder = new this.google.maps.Geocoder()
      const marker = data.replace(' ', '').split(',')
      const location = {}
      this.$set(location, 'latitude', parseFloat(marker[0] || 0))
      this.$set(location, 'longitude', parseFloat(marker[1] || 0))

      if (isNaN(location.latitude) || isNaN(location.longitude)){
        return
      }

      this.currentPlace = {...location}
      let latlng = { lat: location.latitude, lng: location.longitude };
      geocoder.geocode({ 'location': latlng }, (response) => {
        this.$emit('setAlamat', response)
      })

      this.setMarker();
      this.$emit("changeLocation", location, this.radius);
    }
  },
  watch: {
    mapUpdated() {
      // resetPathAreaPresensi path areaAbsensi jika form dibuka ulang
      this.resetPathAreaPresensi();
    },
  },
};
</script>

<style>
.btn {
  margin-bottom: 5px;
  border: 1px solid rgb(128, 123, 123);
  border-radius: 5px;
  color: white;
  background-color: #009688;
  font-size: 15px;
  font-weight: 00;
  outline: none;
  height: 30px;
  line-height: 10px;
  text-align: left;
}
.search-location {
  color: rgba(0, 0, 0, 0.87);
  padding: 9px 8px 9px;
  max-width: 100%;
  width: 100%;
  border: 1px solid grey;
  outline: 1px;
  background: transparent;
  border-radius: 4px;
}
</style>
